import SearchSuggestionContent from './SearchSuggestionContent';

export default SearchSuggestionContent;
